import styled from "styled-components";

const InputContainer = styled('div')`
  margin-bottom: 20px;
  max-width: 340px;
`;

export default InputContainer;
